import { makeStyles } from "@mui/styles";

const useStyles: any = makeStyles(() => ({
  view: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    minHeight: 0,
    padding: "16px",
    boxSizing: "border-box"
  },

  loadingContainer: {
    display: "flex",
    flex: 1,
    alignItems: "center",
    justifyContent: "center"
  },

  actionsRow: {
    display: "flex",
    gap: "10px",
    flexWrap: "wrap",
    marginBottom: "16px",
    flexShrink: 0
  },

  actionButton: {
    textTransform: "none"
  },

  reportDate: {
    marginLeft: "auto",
    alignSelf: "center",
    fontSize: "12px",
    color: "#736973",
    whiteSpace: "nowrap"
  },

  contentRow: {
    display: "flex",
    flex: 1,
    minHeight: 0,
    flexWrap: "nowrap",
    alignItems: "stretch"
  },

  tableWrapper: {
    display: "flex",
    flex: 1,
    minWidth: 0,
    minHeight: 0
  }
}));

export default useStyles;
